var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8425 6.97453C23.8425 4.86516 22.2909 3.16828 20.3738 3.16828C17.7769 3.04687 15.1284 3 12.4219 3H11.5781C8.87813 3 6.225 3.04687 3.62813 3.16875C1.71563 3.16875 0.164065 4.875 0.164065 6.98437C0.0468778 8.65266 -0.00280974 10.3214 2.76303e-06 11.9902C-0.00468474 13.6589 0.0484403 15.3292 0.159378 17.0011C0.159378 19.1105 1.71094 20.8214 3.62344 20.8214C6.35157 20.948 9.15 21.0042 11.9953 20.9995C14.8453 21.0089 17.6359 20.9495 20.3672 20.8214C22.2844 20.8214 23.8359 19.1105 23.8359 17.0011C23.9484 15.3277 24 13.6589 23.9953 11.9855C24.0059 10.3167 23.955 8.64641 23.8425 6.97453ZM9.70313 16.5886V7.37766L16.5 11.9808L9.70313 16.5886Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic-youtube.c6b0d49d0c70ed475287c4d4855df8e5.svg";
export { ForwardRef as ReactComponent };